var React = require('react');

function ForwardCarrotIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.43768 5.32079L0.486328 1.36944L1.37432 0.481445L5.76967 4.87679C6.01488 5.12201 6.01488 5.51958 5.76967 5.76479L1.37432 10.1601L0.486328 9.27214L4.43768 5.32079Z","fill":"#D71C2E"}));
}

ForwardCarrotIcon.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 6 11","fill":"none"};

module.exports = ForwardCarrotIcon;

ForwardCarrotIcon.default = ForwardCarrotIcon;
